import React from "react";
import { useFetch, loading } from "../../helpers/hooks.jsx";
import "./contacts.css";
import json_navbar from "../UI/Navbar/Navbar.json";

const Contacts = ({ lang }) => {
  const [contacts, loadingContacts] = useFetch("https://sancta-cecilia.cz/contacts_json.php");
  const [bank, loadingBank] = useFetch("/bank.json");

  return (
    <div className="contacts">
      <h1>{json_navbar.contacts[lang]}</h1>
      <div
        className="contactBank"
        dangerouslySetInnerHTML={{
          __html: loadingBank ? loading[lang] : bank[lang],
        }}
      ></div>
      <div className="contactsContainer">
        {loadingContacts
          ? loading[lang]
          : contacts.map((contact, index) => (
              <div key={index} className="contact">
                <div className="contactName">{contact.jmeno}</div>
                <div className="contactPhone">{contact.telefony}</div>
                <div className="contactEmail">{contact.email}</div>
              </div>
            ))}
      </div>
    </div>
  );
};

export default Contacts;



// WEBPACK FOOTER //
// ./src/components/Contacts/Contacts.jsx